import {
  DataTable,
  DataTableColDef,
  DataTableColumnHeader,
} from "@/lib/Components/DataTable/DataTable";
import {
  OrganisationUserItem,
  organisationUsersQuery,
} from "@/app/Organisations/GraphQL/organisationUsersQuery";
import { TimeSinceNow } from "@/lib/Components/Common/TimeSinceNow";
import { DeEmphasisedCell } from "@/lib/Components/DataTable/DeEmphasisedCell";
import { Button } from "@/components/catalyst/button";
import { PlusIcon, UserPlusIcon } from "@heroicons/react/16/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { InviteOrganizationMemberDialog } from "@/app/Settings/Settings/Components/InviteOrganizationMemberDialog";
import { AddOrganisationMemberDialog } from "@/app/Organisations/Components/AddOrganisationMemberDialog";

type ColumnId = "name" | "email" | "joined";

const columns: DataTableColDef<OrganisationUserItem, any, ColumnId>[] = [
  {
    id: "name",
    accessorFn: (row) => row.user?.name ?? "--",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
  },
  {
    id: "email",
    accessorFn: (row) => row.user?.primary_email ?? "--",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: DeEmphasisedCell,
  },
  {
    id: "joined",
    accessorFn: (row) => row.created_at,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Joined" />
    ),
    cell: ({ row }) => <TimeSinceNow time={row.original.created_at} />,
  },
];

export function OrganisationMembersTable({
  organisationId,
}: {
  organisationId: string;
}) {
  const { open: openInviteDialog } = useDialog(InviteOrganizationMemberDialog);
  const { open: openAddMemberDialog } = useDialog(AddOrganisationMemberDialog);

  return (
    <DataTable
      id="organisation-members"
      columns={columns}
      document={organisationUsersQuery}
      accessor={(res) => res.organisationUsers}
      getQueryVariables={({ pagination }) => ({
        organisation_id: organisationId,
        page: pagination.pageIndex,
        first: pagination.pageSize,
      })}
      searchable={false}
      columnToggles={false}
      rightButtons={
        <>
          <Button
            outline
            onClick={() =>
              openAddMemberDialog({ organisationId: organisationId })
            }
          >
            <UserPlusIcon />
            Add user
          </Button>
          <Button
            onClick={() =>
              openInviteDialog({ organisation_id: organisationId })
            }
          >
            <PlusIcon />
            Invite user
          </Button>
        </>
      }
    />
  );
}
